import * as React from "react";
import { FetchWithAuth } from "digimaker-ui/util";
import {
  Alert,
  Breadcrumb,
  Button,
  Col,
  Divider,
  Row,
  Space,
  Table,
} from "antd";
import { Link } from "react-router-dom";
import { CloseCircleOutlined } from "@ant-design/icons";
import { util } from "../lib/Util";
import { useState } from "react";
import { Overall } from "./ResultList";

export default class SubjectResultView extends React.Component<
  { id: string },
  { data: any; subjects: any }
> {
  constructor(props: any) {
    super(props);
    this.state = { data: "", subjects: {} };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    FetchWithAuth("icd/subject/result/list?student=" + this.props.id)
      .then((data) => {
        if (data.data.length == 0) {
          throw Error("Student not found!");
        }

        return data.data[0];
      })
      .then((data) => {
        if (data.stage) {
          for (let year = 1; year <= data.stage; year++) {
            FetchWithAuth(
              "content/list/subject?sortby=c.name%20asc&limit=0&offset=0&field.stage_year=" +
                year +
                "&field.course=" +
                data.course,
            )
              .then((data1) => {
                let subjects = this.state.subjects;
                subjects[year] = data1.data.list;
                this.setState({ data: data, subjects: subjects });
              })
              .catch((err) => {
                this.setState(() => {
                  throw err;
                });
              });
          }
        } else {
          FetchWithAuth(
            "content/list/subject?sortby=c.name%20asc&limit=0&offset=0&field.course=" +
              data.course,
          )
            .then((data1) => {
              let subjects = this.state.subjects;
              subjects[""] = data1.data.list;
              this.setState({ data: data, subjects: subjects });
            })
            .then((data1) => {
              let subjects = this.state.subjects;
              subjects[""] = data1.list;
              this.setState({ data: data, subjects: subjects });
            })
            .catch((err) => {
              this.setState(() => {
                throw err;
              });
            });
        }
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  render() {
    let data = this.state.data;
    if (!data) {
      return "";
    }

    let allSubjects = [];
    Object.keys(this.state.subjects).map((year) => {
      this.state.subjects[year].map((item) => {
        allSubjects.push(item);
      });
    });

    return (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/subject/result/list">Subject result list</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>View</Breadcrumb.Item>
        </Breadcrumb>

        <div className="main-top">
          <h2>
            {data.firstname} {data.lastname}({data.student_no})
          </h2>
        </div>

        <h3>Subject Results</h3>
        {Object.keys(this.state.subjects)
          .sort((a: string, b: string) => parseInt(b) - parseInt(a))
          .map((year) => (
            <div>
              <br />
              <h2>Year: {year}</h2>
              <Alert
                message={
                  <span>
                    {" "}
                    Overall:{" "}
                    <Overall
                      id={data.id}
                      stageYear={year}
                      value={data.score_overall}
                      onUpdated={() => {
                        this.fetchData();
                      }}
                    />{" "}
                    &nbsp;&nbsp; Average:{" "}
                    {util.getResultsAverage(
                      data.results,
                      this.state.subjects[year],
                      this.state.data.stu_course.is_bachelor,
                    )}
                  </span>
                }
              />
              <br />
              {this.state.subjects[year].map((subject) => (
                <div>
                  <SubjectResult
                    subject={subject}
                    results={data.results.filter(
                      (item) => item["subject_id"] === subject["id"],
                    )}
                  />
                </div>
              ))}
            </div>
          ))}

        <br />
        <Space>
          <a href="javascript:history.go(-1)">
            <CloseCircleOutlined /> Back
          </a>
        </Space>
      </div>
    );
  }
}

const SubjectResult = (props: { results: any; subject: any }) => {
  const [shown, setShown] = useState(false);

  const columns = [
    { title: "Subject", dataIndex: "subject", key: "subject" },
    { title: "Assessment", dataIndex: "assessment", key: "assessment" },
    { title: "Score", dataIndex: "score", key: "score" },
    {
      title: "Percentage",
      dataIndex: "percentage",
      key: "percentage",
      render: (text) => text + "%",
    },
    {
      title: "Repeat",
      dataIndex: "repeat_no",
      key: "repeat_no",
      render: (text, record) => {
        if (record["is_repeat"]) {
          if (text === 0) {
            return "-";
          }
          return text;
        } else {
          return "-";
        }
      },
    },
  ];

  return (
    <div>
      <h4>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShown(!shown);
          }}
        >
          {props.subject.name} ({props.subject.credit}):{" "}
          {util.washResult(util.calculateResult(props.results))}
        </a>
      </h4>
      <Table
        style={{ display: shown ? "block" : "none" }}
        columns={columns}
        dataSource={props.results}
        pagination={false}
        size="middle"
      />
    </div>
  );
};
